import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

// SPA port of /app/admin/analytics/_components/DealStatusBarChart.tsx.
// Stage-id-keyed colors fall back to the neutral chart accent when the
// HubSpot stage doesn't match one of the legacy DealStatus enum keys.

const FILL: Record<string, string> = {
  submitted: "hsl(var(--status-submitted))",
  under_review: "hsl(var(--status-review))",
  approved: "hsl(var(--status-approved))",
  active: "hsl(var(--status-active))",
  closed_won: "hsl(var(--status-won))",
  closed_lost: "hsl(var(--status-lost))",
};
const DEFAULT_FILL = "hsl(var(--accent))";

export function DealStatusBarChart({
  data,
}: {
  data: Array<{ status: string; label: string; count: number }>;
}) {
  return (
    <div className="h-[300px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
          <CartesianGrid stroke="hsl(var(--border))" strokeDasharray="3 3" vertical={false} />
          <XAxis
            dataKey="label"
            tick={{ fontSize: 11, fill: "hsl(var(--muted-foreground))" }}
            tickLine={false}
            axisLine={{ stroke: "hsl(var(--border))" }}
          />
          <YAxis
            allowDecimals={false}
            tick={{ fontSize: 11, fill: "hsl(var(--muted-foreground))" }}
            tickLine={false}
            axisLine={false}
            width={28}
          />
          <Tooltip
            cursor={{ fill: "hsl(var(--muted))" }}
            contentStyle={{
              background: "hsl(var(--card))",
              border: "1px solid hsl(var(--border))",
              borderRadius: 8,
              fontSize: 12,
            }}
            labelStyle={{ color: "hsl(var(--muted-foreground))" }}
          />
          <Bar dataKey="count" radius={[6, 6, 0, 0]}>
            {data.map((d) => (
              <Bar key={d.status} dataKey="count" fill={FILL[d.status] ?? DEFAULT_FILL} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
